<div class="aig-historyPolicy u-my-8 container u-minheight-vh-60">
    <div class="row u-justify-center">
        <div class="col-12">
            <aig-breadcrumb class="" [config]="[{ title: 'Inicio', link: '/area-cliente' }]">
            </aig-breadcrumb>
        </div>
        <div class="col-12 col-md-8 u-mt-8">
            <section>
                <div class="u-ds-grid u-gap-40">
                    <!-- Title -->
                    <h1 class="u-color-primary1 u-fw-400 u-h1 u-text-center">
                        Historial de pólizas
                    </h1>
                    <!-- Póliza activa -->
                     @if (this.isPolicyActive) {
                         <div class="u-ds-grid u-gap-24" >
                             <h2 class="u-color-primary1 u-fw-500 u-h3">Póliza activa</h2>
                             <table class="c-table u-overx-auto">
                                 <thead class="u-fs-20">
                                     <th>Número de póliza</th>
                                     <th>Decha de inicio</th>
                                     <th>Estado</th>
                                 </thead>
                                 <tbody>
                                     <tr *ngFor="let policy of activePolicies">
                                         <td class="u-fs-20">
                                             {{ policy.num_Poliza}}
                                         </td>
                                         <td class="u-fs-18">
                                             {{ policy.fecha_Inicio_Cobertura| date : "dd/MM/yyyy" : "No disponible" }}
                                         </td>
                                         <td>
                                             <span class="e-badge u-fs-14">
                                                 {{ policy.estado_Poliza }}
                                             </span>
                                         </td>
                                         <td>
                                             <a class="e-btn--link u-fw-600"
                                             (click)="goToPolicyDetail(policy)">
                                                 Ver detalle
                                             </a>
                                         </td>
                                     </tr>
                                 </tbody>
                             </table>
                         </div>
                     }@else {
                        <div class="u-ds-grid">
                            <div class="u-text-center u-mb-3">
                                <p>Actualmente no tienes ninguna póliza activa.</p>
                            </div>

                            <div class="p-flexcc">
                                <button class="e-btn--primary p-flexcc u-fw-500">
                                    <p>Vuelve a protegerte con el seguro MicroCyber</p>
                                </button>
                            </div>
                        </div>
                     }
                <!-- Otras pólizas -->
                 @if (hasExpiredPolicies)  {
                    <div class="u-ds-grid u-gap-24">
                        <h2 class="u-color-primary1 u-fw-500 u-h3">
                            Otras pólizas
                        </h2>
                        <table class="c-table">
                            <thead class="u-fs-20">
                                <th>Número de póliza</th>
                                <th>Decha de inicio</th>
                                <th>Estado</th>
                            </thead>
                            <tbody>
                                @for (policy of expiredPolicies; track policy.idEstado) {
                                    <tr>
                                        <td class="u-fs-20">
                                            {{ policy.num_Poliza}}
                                        </td>
                                        <td class="u-fs-18">
                                            {{ policy.fecha_Inicio_Cobertura| date : "dd/MM/yyyy" : "No disponible" }}
                                        </td>
                                        <td>
                                            <span class="e-badge u-fs-14" [ngClass]="policyState(policy.idEstado)">
                                                {{ policy.estado_Poliza }}
                                            </span>
                                        </td>
                                        <td>
                                            <a class="u-btn__link u-fs-16 u-fw-600"
                                            (click)="goToPolicyDetail(policy)" >
                                                Ver detalle
                                            </a>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                 }
                </div>
            </section>
        </div>
    </div>
</div>
